import Icon from "elements/Icon";
import ModalSymphony from "elements/ModalSymphony";
import useCampaign from "Hooks/useCampaign";
import useCurrentBrand, { BrandExistsState } from "Hooks/useCurrentBrand";
import Sty from "modules/Sty";
import { clsx, getCampaignTypeInfo } from "modules/Utils";
import FinalizationCampaignView from "./CampaignViews/FinalizationCampaignView";
import { CSSProperties, useState } from "react";
import TabsSymphony, { TabItem } from "elements/TabsSymphony";
import { PlaybookType } from "modules/Const";

const CONTENT_TABS: TabItem[] = [
    {
        id: 'ig-feed',
        title: 'Feed',
    },
    {
        id: 'ig-story',
        title: 'Story',
    },
    {
        id: 'ig-reels',
        title: 'Reels',
    },
]

interface OneClickCampaignModalProps {
    className?: string
}

// NOTE: component()
const OneClickCampaignModal = ({
    className,
}: OneClickCampaignModalProps) => {
    const {
        playbookType,
        showOneClickCampaignModal,
        setShowOneClickCampaignModal
    } = useCampaign();
    const { currentBrand } = useCurrentBrand() as BrandExistsState;

    const [selectedContentTab, setSelectedContentTab] = useState<TabItem>(CONTENT_TABS[0]);

    const handleRegenerate = () => {
        console.log('Regenerate');
    }

    const handleStartCampaign = () => {
        console.log('Start Campaign');
    }

    const renderLeftSideContent = () => {
        return (
            <div className="oneClickCampaignModalLeftSideContent" style={sty.oneClickCampaignModalLeftSideContent}>
                <TabsSymphony
                    className="oneClickCampaignModalLeftSideContentTabs"
                    tabs={CONTENT_TABS}
                    selectedTab={selectedContentTab.id}
                    onChange={(tab) => setSelectedContentTab(tab as TabItem)}
                    style={{
                        backgroundColor: 'white',
                        width: 'fit-content',
                        borderRadius: 1000,
                        paddingLeft: 16,
                        paddingRight: 16,
                    }}
                />
                <div className="oneClickCampaignModalAdPreview" style={sty.oneClickCampaignModalAdPreview}>
                    Ad Preview Placeholder
                </div>
                {/* <AdPreview
                    username="test"
                    callToActionLabel="test"
                    profilePicUrl="test"
                    previewedAsset={null}
                    captions={[]}
                    previewType={selectedContentTab.id}
                /> */}
            </div>
        )
    }

    const renderAiHeader = () => {
        return (
            <div
                className="oneClickCampaignModalCloseIconContainer"
                style={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: 4
                }}
            >
                <Icon
                    className="oneClickCampaignModalCloseIcon"
                    icon="maestroBadgeImage"
                    size={32}
                />
                <div className="oneClickCampaignModalCloseIconTitle" style={Sty.text16grey}>
                    Marketing Campaign by AI
                </div>
            </div>
        )
    }

    const renderTitle = () => {
        return (
            <div className="oneClickCampaignModalTitle" style={Sty.text24bold}>
                {getCampaignTypeInfo(playbookType as PlaybookType).title} for {currentBrand?.name}
            </div>
        )
    }

    // NOTE: render()
    return (
        <ModalSymphony
            className={clsx(
                'oneClickCampaignModal',
                className
            )}
            isOpen={showOneClickCampaignModal}
            onClose={() => setShowOneClickCampaignModal(false)}
            size="large"
            leftSideContent={renderLeftSideContent()}
            style={{ gap: 8 }}
            buttonLeftText="Regenerate"
            buttonRightText="Start Campaign"
            onClickButtonLeft={handleRegenerate}
            onClickButtonRight={handleStartCampaign}
            isIsolateModalContent
        >
            {renderAiHeader()}
            {renderTitle()}
            <FinalizationCampaignView
                className="oneClickCampaignModalFinalizationCampaignView"
                isTitle={false}
            />
        </ModalSymphony>
    )
}

const sty: Record<string, CSSProperties> = {
    oneClickCampaignModalLeftSideContent: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        background: 'linear-gradient(135deg, rgba(111, 66, 193, 0.9) 0%, rgba(72, 149, 239, 0.8) 100%)',
        height: '100%',
        padding: 24,
        boxShadow: 'inset 0px 0px 20px 0px rgba(0, 0, 0, 0.5)',
        gap: 24,
        borderBottomLeftRadius: 16,
        borderTopLeftRadius: 16,
    },
    oneClickCampaignModalAdPreview: {
        width: 280,
        height: 450,
        backgroundColor: 'white',
        borderRadius: 16,
        padding: 16,
        boxShadow: '0px 0px 20px 0px rgba(0, 0, 0, 0.5)',
    }
}

export default OneClickCampaignModal;